import React from 'react';
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
import Icon from '@material-ui/core/Icon';


import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import ListIcon from '@material-ui/icons/List';

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.info.light,
    }
  }
}));

export const CategoryListNav = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div>
      <Button
          variant="outlined"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<AddIcon />}
          onClick={() => history.push('/categories/create')}
        >
          Create New Category
        </Button>
</div>
  );
}

export const CreateCategoryNav = () => {
    const classes = useStyles();
    const history = useHistory();
  
    return (
      <div>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<ListIcon />}
          onClick={() => history.push('/categories')}
        >
         List of Categories
        </Button>
      </div>
    );
  }

export const CategoryNav = () => {
    const classes = useStyles();
    const history = useHistory();
  
    return (
      <div>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<AddIcon />}
          onClick={() => history.push('/categories/create')}
        >
          Create New Category
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<ListIcon />}
          onClick={() => history.push('/categories')}
        >
         List of Categories
        </Button>
      </div>
    );
  }
  
  
